import React, { ReactElement } from 'react';

// The Phill/Panenco play-mark: an orange triangle pointing right over a dark triangle pointing left.
// The dark triangle uses `currentColor` so it stays legible in both light and dark themes.
// Colors are set via inline `style` (not the `fill` attribute) so the global "svg [fill] -> currentColor"
// rule in globals.css doesn't monochrome the brand orange.
export const PhillLogo = ({ className }: { className?: string }): ReactElement => (
  <svg viewBox="0 0 800 800" className={className} role="img" aria-label="Phill">
    <polygon points="285,150 285,490 575,320" style={{ fill: '#EA5A1D' }} />
    <polygon points="465,485 465,665 283,575" style={{ fill: 'currentColor' }} />
  </svg>
);

export default PhillLogo;
